import React, { useState } from 'react';

const ContentTab = ({ updateWhatsAppTabData,whatsAppTabData }) => {
    const [bubbleText, setBubbleText] = useState(whatsAppTabData.content_bubble_text);
    const [chatWindowImage, setChatWindowImage] = useState(whatsAppTabData.content_chat_window_picture);
    const [chatWindowName, setChatWindowName] = useState(whatsAppTabData.content_chat_window_name);
    const [welcomeMessage, setWelcomeMessage] = useState(whatsAppTabData.content_welcome_message);
    const [startChatMethodType, setStartChatMethodType] = useState(whatsAppTabData.content_start_chat_method);
    const [startChatButtonText, setStartChatButtonText] = useState(whatsAppTabData.content_start_chat_button_text);
    const [showShowIconinButton, setShowIconinButton] = useState(Number(whatsAppTabData.content_is_show_icon_in_button));
    const [preFilledMessage, setPreFilledMessage] = useState(whatsAppTabData.content_whatsapp_pre_filled_message);
    const [messageFieldPlaceholder, setMessageFieldPlaceholder] = useState(whatsAppTabData.content_whatsapp_message_field_placeholder);

     // Handlers Bubble Text Change
    const handleBubbleTextChange = (event) => {
        const value = event.target.value;
        setBubbleText(value);
        updateWhatsAppTabData("content_bubble_text", value);
    };

    // Handlers Bubble Text Change
    const handleChatWindowImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setChatWindowImage(URL.createObjectURL(file));
            updateWhatsAppTabData("content_chat_window_picture", file);
        }
    }

    // Handlers Chat Window Name Change
    const handleChatWindowNameChange = (event) => {
        const value = event.target.value;
        setChatWindowName(value);
        updateWhatsAppTabData("content_chat_window_name", value);
    };

    // Handlers Welcome Message Change
    const handleWelcomeMessageChange = (event) => {
        const value = event.target.value;
        setWelcomeMessage(value);
        updateWhatsAppTabData("content_welcome_message", value);
    };

    // Handlers Start Chat Button Change
    const handleStartChatMethodTypeChange = (event) => {
        const value = event.target.value;
        setStartChatMethodType(value);
        updateWhatsAppTabData("content_start_chat_method", value);
    };

    // Handlers Start Chat Button Text Change
    const handleStartChatButtonTextChange = (event) => {
        const value = event.target.value;
        setStartChatButtonText(value);
        updateWhatsAppTabData("content_start_chat_button_text", value);
    };

    // Handlers Show Icon in Button Change
    const handleShowIconinButtonChange = (e) => {
        const checked = e.target.checked;
        setShowIconinButton(checked);
        updateWhatsAppTabData("content_is_show_icon_in_button", checked); 
    };

    // Handlers Pre Filled Message Change
    const handlePreFilledMessageChange = (event) => {
        const value = event.target.value;
        setPreFilledMessage(value);
        updateWhatsAppTabData("content_whatsapp_pre_filled_message", value); 
    };


    // Handlers Message Field Placeholder Change
    const handleMessageFieldPlaceholderChange = (event) => {
        const value = event.target.value;
        setMessageFieldPlaceholder(value);
        updateWhatsAppTabData("content_whatsapp_message_field_placeholder", value); 
    };

    return (
        <div className="whats-app-side-baar-content-tab">
            <span>Content</span>
            <div className="name-tile-row">Chat Bubble</div>
            <div className="side-baar-box-header">
                {/*<div className="box-header-row">
                    <span>Bubble Icon</span>
                    <em><button className="button-whtsapp"><img src={`${process.env.PUBLIC_URL}/whats-app/templates/whatsapp-chate.png`} alt="general" /></button></em>
                </div>*/}
                <div className="box-header-row bubble-text">
                    <input type="text" value={bubbleText} onChange={handleBubbleTextChange} placeholder="Bubble Text..." />
                </div>
            </div>
            <div className="name-tile-row">Chat Window</div>
            <div className="side-baar-box-header">
                {/*<div className="box-header-row">
                    <span>Picture</span>
                    <em><button className="button-whtsapp picture"><img src={`${process.env.PUBLIC_URL}/whats-app/templates/general-pro.png`} alt="general" /></button></em>
                </div>*/}
                <div className="box-header-row">
                    <span>Picture</span>
                    <em>
                        <button className="button-whtsapp picture">
                            <img src={chatWindowImage} alt="Uploaded Preview" />
                        </button>
                    </em>
                    <input 
                        type="file" 
                        accept="image/*" 
                        onChange={handleChatWindowImageChange} 
                    />
                </div>
                <div className="box-header-row bubble-text">
                    <label>Name</label>
                    <input type="text" value={chatWindowName} onChange={handleChatWindowNameChange} placeholder="John Doe" />
                </div>
                <div className="box-header-row">
                    <span>Caption</span>
                    <em>{whatsAppTabData.content_chat_window_caption}</em>
                </div>
            </div>
            <div className="name-tile-row">Welcome Message</div>
            <div className="side-baar-box-header">
                <div className="box-header-row welcome-message">
                    <textarea value={welcomeMessage} onChange={handleWelcomeMessageChange} placeholder="Type Message..." defaultValue="Hi there 👋 How can I help you?"></textarea>
                </div>
            </div>
            <div className="name-tile-row">Start Chat Method</div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <ul>
                        <li>
                            <div className="form-group">
                            <input id="test-1" type="radio" name="startChatMethod" value="Start_Chat_Button" onChange={handleStartChatMethodTypeChange} checked={startChatMethodType === 'Start_Chat_Button'}  />
                                <label for="test-1">Start Chat Button
                                    <span>Visitor clicks the button to open Whatsapp and start a conversation with you.</span>
                                </label>
                            </div>
                        </li>
                        <li>
                            <div className="form-group">
                            <input id="test-2" type="radio" name="startChatMethod"  value="Send_Message" onChange={handleStartChatMethodTypeChange} checked={startChatMethodType === 'Send_Message'}/>
                                <label for="test-2">Send Message
                                    <span>Visitor writes a message to you in Whatsapp to start a conversation.</span>
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
                {whatsAppTabData.content_start_chat_method === "Start_Chat_Button" && (
                <>
                <div className="box-header-row bubble-text">
                    <label>Button Text</label>
                    <input type="text" value={startChatButtonText} onChange={handleStartChatButtonTextChange} placeholder="Chat on WhatsApp" />
                </div>
                <div className="box-header-row last-border-none"><span>Show Icon in Button</span>
                    <div className="form-group">
                        <input id="show_icon_in_button_toggle" className="chkbx-toggle" type="checkbox" checked={showShowIconinButton} onChange={handleShowIconinButtonChange} />
                        <label for="show_icon_in_button_toggle"></label>
                    </div>
                </div>
                </>
                )} 

                {whatsAppTabData.content_start_chat_method === "Send_Message" && (
                <>
                {/* <div className="box-header-row"></div> */}
                <div className="side-baar-box-header">
                    <div className="box-header-row bubble-text">
                    <span>Message Field Placeholder</span>
                        <input type="text" value={messageFieldPlaceholder} onChange={handleMessageFieldPlaceholderChange}  placeholder="Enter You Message..." />
                    </div>
                </div>
                <p className='p-tag-padding'>Add the URL of the page from which the chat was initiated to the user's first message.</p>
                </>
                )} 
            </div>
            {whatsAppTabData.content_start_chat_method === "Start_Chat_Button" && (
            <>
                <div className="name-tile-row">Whatsapp pre-filled message</div>
                <div className="side-baar-box-header">
                    <div className="box-header-row bubble-text">
                        <input type="text" value={preFilledMessage} onChange={handlePreFilledMessageChange}  placeholder="Type Message..." />
                    </div>
                </div>
                <p>Customize the default message that appears in Whatsapp when a user initiates a chat. Use [page_url] to include the webpage's URL where the chat started.</p>
            </>
            )} 
        </div>
    );
};

export default ContentTab;